function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#273359",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m51.5 23.0986c4.1421 0 7.5-3.3578 7.5-7.5 0-4.1421-3.3579-7.49997-7.5-7.49997s-7.5 3.35787-7.5 7.49997c0 4.1422 3.3579 7.5 7.5 7.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34 47.4736c0-4.4755 1.7779-8.7677 4.9426-11.9324s7.4569-4.9426 11.9324-4.9426 8.7677 1.7779 11.9324 4.9426 4.9426 7.4569 4.9426 11.9324"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.5 14.9597c4.1421 0 7.5-3.125 7.5-6.97984 0-3.85487-3.3579-6.97986-7.5-6.97986s-7.5 3.12499-7.5 6.97986c0 3.85484 3.3579 6.97984 7.5 6.97984z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1 37.6438c0-4.1651 1.7779-8.1596 4.94257-11.1048 3.16468-2.9452 7.45693-4.5998 11.93243-4.5998s8.7677 1.6546 11.9324 4.5998 4.9426 6.9397 4.9426 11.1048"
}));

var SvgDuelPerson = function SvgDuelPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 49,
    viewBox: "0 0 69 49",
    width: 69,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDuelPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/duel_person.7ae1bce6.svg";
export { ForwardRef as ReactComponent };